import { bootstrap } from '../../../utils/vuex'
import { cloneDeep } from 'lodash'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'
import {
  DEFAULT_AGGREGATIONS,
  DEFAULT_AGGREGATE_COLUMN,
  DEFAULT_AGGREGATE_ROW,
  DEFAULT_AVAILABLE_IN_DETAIL_VIEW,
  DEFAULT_AVAILABLE_IN_LIST,
  DEFAULT_BUTTONS,
  DEFAULT_COLUMNS,
  DEFAULT_CONFIRM_OPTIONS,
  DEFAULT_CURRENT_PARAMETERS,
  DEFAULT_DISABLED,
  DEFAULT_DYNAMIC_STYLE,
  DEFAULT_FETCHING_LIST_DATA,
  DEFAULT_GROUP_ACTIONS_RUNNING,
  DEFAULT_HIDDEN_SEARCH,
  DEFAULT_LIMITATION,
  DEFAULT_LIST_VISIBILITY_OPTIONS,
  DEFAULT_ORDER,
  DEFAULT_PAGER,
  DEFAULT_PRIMARY_KEY,
  DEFAULT_PROCESS_ACTIONS,
  DEFAULT_PROCESS_ACTIONS_BUTTONS,
  DEFAULT_ROW_CLASSES,
  DEFAULT_ROW_DETAILS,
  DEFAULT_ROW_STYLES,
  DEFAULT_COLUMN_CLASSES,
  DEFAULT_COLUMN_STYLES,
  DEFAULT_CELL_CLASSES,
  DEFAULT_CELL_STYLES,
  DEFAULT_ROW_SELECTION_MODE,
  DEFAULT_SEARCH_PARAMS,
  DEFAULT_SEARCH_PARAMS_COMP,
  DEFAULT_SELECTED_GROUP_ACTION,
  DEFAULT_SELECTED_QUEUE_ACTION,
  DEFAULT_SELECTED_ROW,
  DEFAULT_SELECTED_ROWS,
  DEFAULT_SELECTED_ROWS_FILTER,
  DEFAULT_SHOW_IN_LIST,
  DEFAULT_SHOW_LIST_ON_START,
  DEFAULT_UNIVERSAL_FILTER,
  DEFAULT_VISIBLE_COLUMNS,
  DEFAULT_EXPANDED_ROWS,
  VIEW_MODE_GRID,
} from '../../../components/list-new/lib/list-constants'

const state = () => {
  return cloneDeep({
    listProperties: {
      aggregations: DEFAULT_AGGREGATIONS,
      aggregateColumn: DEFAULT_AGGREGATE_COLUMN,
      aggregateRow: DEFAULT_AGGREGATE_ROW,
      availableInDetailView: DEFAULT_AVAILABLE_IN_DETAIL_VIEW,
      availableInList: DEFAULT_AVAILABLE_IN_LIST,
      buttons: DEFAULT_BUTTONS,
      columns: DEFAULT_COLUMNS,
      confirmOptions: DEFAULT_CONFIRM_OPTIONS,
      currentParameters: DEFAULT_CURRENT_PARAMETERS,
      defaultShowInList: DEFAULT_SHOW_IN_LIST,
      disabled: DEFAULT_DISABLED,
      dynamicStyle: DEFAULT_DYNAMIC_STYLE,
      fetchingListData: DEFAULT_FETCHING_LIST_DATA,
      groupActionsRunning: DEFAULT_GROUP_ACTIONS_RUNNING,
      hiddenSearch: DEFAULT_HIDDEN_SEARCH,
      limitation: DEFAULT_LIMITATION,
      listVisibilityOptions: DEFAULT_LIST_VISIBILITY_OPTIONS,
      orderState: DEFAULT_ORDER,
      primaryKey: DEFAULT_PRIMARY_KEY,
      processActions: DEFAULT_PROCESS_ACTIONS,
      processActionsButtons: DEFAULT_PROCESS_ACTIONS_BUTTONS,
      rowClasses: DEFAULT_ROW_CLASSES,
      rowDetails: DEFAULT_ROW_DETAILS,
      rowStyles: DEFAULT_ROW_STYLES,
      columnClasses: DEFAULT_COLUMN_CLASSES,
      columnStyles: DEFAULT_COLUMN_STYLES,
      cellClasses: DEFAULT_CELL_CLASSES,
      cellStyles: DEFAULT_CELL_STYLES,
      rowSelectionMode: DEFAULT_ROW_SELECTION_MODE,
      searchParams: DEFAULT_SEARCH_PARAMS,
      searchParamsComp: DEFAULT_SEARCH_PARAMS_COMP,
      selectedGroupAction: DEFAULT_SELECTED_GROUP_ACTION,
      selectedQueueAction: DEFAULT_SELECTED_QUEUE_ACTION,
      selectedRow: DEFAULT_SELECTED_ROW,
      selectedRows: DEFAULT_SELECTED_ROWS,
      selectedRowsFilter: DEFAULT_SELECTED_ROWS_FILTER,
      showInList: DEFAULT_SHOW_IN_LIST,
      showListOnStart: DEFAULT_SHOW_LIST_ON_START,
      universalFilter: DEFAULT_UNIVERSAL_FILTER,
      viewMode: VIEW_MODE_GRID,
      visibleColumns: DEFAULT_VISIBLE_COLUMNS,
      expandedRows: DEFAULT_EXPANDED_ROWS,
    },
    pager: DEFAULT_PAGER,
    props: {},
    listData: [],
    recordsFiltered: 0,
    recordsTotal: 0,
    expressionChain: {},
    fieldPropertiesMap: {},
    fieldPathMap: {},
    triggerNames: {},
  })
}

export default bootstrap({
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
})
